<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-5">Forgot password?</h2>
      <p class="mt-5 mb-4 pb-1 text--lg">
        </p>
      <app-password-restore-withpin-confirm-form
                                         (submitEvent)="confirm($event)"
      ></app-password-restore-withpin-confirm-form>
    </div>
  </div>
</div>

